import React from 'react';
import { Link } from 'react-router-dom';
import { Popup } from 'react-leaflet';

export default function TractPopup({ tract }) {
    if (!tract) return null;

    const owners = [
        ...(tract.mineralsOwned || []).map((o) => o.Owner?.name),
        ...(tract.surfaceOwned  || []).map((o) => o.Owner?.name),
    ].filter(Boolean);
    const uniqueOwners = [...new Set(owners)];

    return (
        <Popup>
            <div style={{ fontSize: '0.85rem', lineHeight: 1.5, minWidth: 180 }}>
                <Link to={`/Lands/${tract.id}`} style={{ fontWeight: 'bold', fontSize: '0.9rem' }}>
                    {tract.id}{tract.name ? ` — ${tract.name}` : ''}
                </Link>
                <br />
                {tract.county}, {tract.state}
                <hr style={{ margin: '4px 0', borderColor: '#ddd' }} />
                {tract.grossMineralAcres != null && <div>Mineral Acres: <strong>{tract.grossMineralAcres}</strong></div>}
                {tract.grossSurfaceAcres != null && <div>Surface Acres: <strong>{tract.grossSurfaceAcres}</strong></div>}
                {tract.surfaceFraction    && <div>Surface Fraction: <strong>{tract.surfaceFraction}</strong></div>}
                {tract.wellCount > 0      && <div>Wells: <strong>{tract.wellCount}</strong></div>}
                {uniqueOwners.length > 0 && (
                    <div>Owner{uniqueOwners.length > 1 ? 's' : ''}: <strong>{uniqueOwners.join(', ')}</strong></div>
                )}
            </div>
        </Popup>
    );
}
